<p-select [options]="options()"
          [optionLabel]="optionLabel()"
          [optionValue]="optionValue()"
          [optionDisabled]="primeNgOptionDisabledField()"
          [placeholder]="placeholder()"
          [showClear]="showClear()"
          [disabled]="disabled()"
          [filter]="filter()"
          [filterBy]="filterBy()"
          [filterPlaceholder]="filterPlaceholder()"
          [ariaFilterLabel]="filterPlaceholder()"
          [resetFilterOnHide]="resetFilterOnHide()"
          [autofocusFilter]="autoFocusFilter()"
          [panelStyleClass]="panelStyleClass()"
          [ngModel]="value()"
          (onChange)="handleChange($event)"
          (onFilter)="handleFilter($event)"
          styleClass="w-full"
          [class.input-invalid]="invalid()"
          [appendTo]="appendTo()"
          [attr.id]="inputId() || null"
          [attr.data-testid]="testId()">
  <ng-template #selectedItem
               let-option>
    {{ displayLabel(option) }}
  </ng-template>
  <ng-template #item
               let-option>
    <div class="select-option-shell"
         [class.select-option-shell--disabled]="isOptionDisabled(option)"
         (click)="handleDisabledOptionActivate($event, option)">
      @if (selectOptionItemTemplate) {
        <ng-container [ngTemplateOutlet]="selectOptionItemTemplate"
                      [ngTemplateOutletContext]="optionContext(option)" />
      } @else {
        <div class="select-option-row"
             [class.select-option-row--disabled]="isOptionDisabled(option)">
          <span class="select-option-row__label">{{ displayLabel(option) }}</span>
        </div>
      }
    </div>
  </ng-template>
  <ng-template #emptyfilter>
    @if (emptyFilterTemplate()) {
      <ng-container [ngTemplateOutlet]="emptyFilterTemplate()!" />
    } @else {
      <span class="select-empty body-md-regular">No results found</span>
    }
  </ng-template>
</p-select>
